import { faHourglassHalf } from "@fortawesome/free-solid-svg-icons";
import { ModalDialog } from "../AppDataProvider/types";
import React from "react";
const onClick = () => console.log("You clicked the button");
export const defaultModalDialog: ModalDialog = {
  buttonLabel: "Click me",
  content: "This is a modal dialog. You have to interact with it to move on.",
  icon: faHourglassHalf,
  onClick,
  title: "Modal dialog"
};
export const modalDialogWithComplexContent: ModalDialog = {
  buttonLabel: "Click me",
  content: <>
      <div>This modal dialog has more than one section in its content</div>
      <div>
        It also has a <a href="https://isitchristmas.com">hyperlink</a>.
      </div>
    </>,
  icon: faHourglassHalf,
  onClick,
  title: "Modal dialog with complex content"
};